/**
 * @generated SignedSource<<dfca6ac73429a4be662a141d1b564256>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type plusWidgetQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"hooksPlusWidgetConfigQuery" | "plusWidgetHasAccessQuery">;
  readonly " $fragmentType": "plusWidgetQuery";
};
export type plusWidgetQuery$key = {
  readonly " $data"?: plusWidgetQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"plusWidgetQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "applicationId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "dailyPulseTypeUuId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "highlightQueueName"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "plusNewsAgendaEndDate"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "plusNewsAgendaStartDate"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "plusNewsAgendaTypes"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "plusWidgetQuery",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "applicationId",
          "variableName": "applicationId"
        },
        {
          "kind": "Variable",
          "name": "dailyPulseTypeUuId",
          "variableName": "dailyPulseTypeUuId"
        },
        {
          "kind": "Variable",
          "name": "highlightQueueName",
          "variableName": "highlightQueueName"
        },
        {
          "kind": "Variable",
          "name": "plusNewsAgendaEndDate",
          "variableName": "plusNewsAgendaEndDate"
        },
        {
          "kind": "Variable",
          "name": "plusNewsAgendaStartDate",
          "variableName": "plusNewsAgendaStartDate"
        },
        {
          "kind": "Variable",
          "name": "plusNewsAgendaTypes",
          "variableName": "plusNewsAgendaTypes"
        }
      ],
      "kind": "FragmentSpread",
      "name": "plusWidgetHasAccessQuery"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "hooksPlusWidgetConfigQuery"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "36e08e24bdf17ed817c79128a019e50c";

export default node;
